export default {
  props: {
    icon: Array
  }
};